import type { FC } from 'react';
import { useSportUrlParams } from '@mwl/core-lib';
import type { PopupClasses } from '@/components/Popup/Popup';
import { Popup } from '@/components/Popup/Popup';
import { SportSearch } from '@/components/SportSearch/SportSearch';
import { SportSearchInput } from '../SportSearchInput/SportSearchInput';
import { analytics } from './SearchPopup.analytics';
import type { SearchPopupProps } from './SearchPopup.types';
import styles from './SearchPopup.module.scss';
const popupClasses: PopupClasses = {
  container: styles.containerPopup,
  wrapper: styles.wrapperPopup,
  overlay: styles.overlayPopup
};
export const SearchPopup: FC<SearchPopupProps> = ({
  searchRef,
  handleClosePopup,
  ...params
}) => {
  const {
    search
  } = useSportUrlParams();
  return <Popup show={!!search} analytics={analytics} classes={popupClasses} onClose={handleClosePopup} data-sentry-element="Popup" data-sentry-component="SearchPopup" data-sentry-source-file="SearchPopup.tsx">
      <div ref={searchRef} className={styles.root}>
        <SportSearchInput isMobile className={styles.search} searchRef={searchRef} {...params} data-sentry-element="SportSearchInput" data-sentry-source-file="SearchPopup.tsx" />
      </div>
      <SportSearch data-sentry-element="SportSearch" data-sentry-source-file="SearchPopup.tsx" />
    </Popup>;
};